import axios from '@/axios.js'

const state = () => ({
    bahanbangunans: []
})

const mutations = {
    SET_BAHANBANGUNANS (state, payload) {
      state.bahanbangunans = payload
    },
    ADD_BAHANBANGUNAN (state, item) {
      state.bahanbangunans.unshift(item)
    },
    UPDATE_BAHANBANGUNAN (state, bahanbangunan) {
      const bahanbangunanIndex = state.bahanbangunans.findIndex((p) => p.id === bahanbangunan.id)
      Object.assign(state.bahanbangunans[bahanbangunanIndex], bahanbangunan)
    },
    REMOVE_BAHANBANGUNAN (state, itemId) {
      const ItemIndex = state.bahanbangunans.findIndex((p) => p.id === itemId)
      state.bahanbangunans.splice(ItemIndex, 1)
    },
}

const actions = {
  fetchBahanBangunan ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list/bahan-bangunan`)
        .then((response) => {
          commit('SET_BAHANBANGUNANS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addBahanBangunan ({ commit }, bahanbangunan ) {
    return new Promise((resolve, reject) => {
      axios.post('/term-add', bahanbangunan)
        .then((response) => {
          commit('ADD_BAHANBANGUNAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateBahanBangunan ({ commit }, bahanbangunan) {
    return new Promise((resolve, reject) => {
      axios.post(`/term-update/${bahanbangunan.id}`, bahanbangunan)
        .then((response) => {
            commit('UPDATE_BAHANBANGUNAN', response.data.data)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeBahanBangunan ({ commit }, bahanbangunan) {
    return new Promise((resolve, reject) => {
      axios.delete(`/term-delete/${bahanbangunan.id}`)
        .then((response) => {
            commit('REMOVE_BAHANBANGUNAN', bahanbangunan.id)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}